import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators'
import store from '@/store'
import ThingModel, {Resource, Tsl} from "@/model/ThingModel";
import {Container} from "typescript-ioc";
import ThingModelApi from "@/module/thing/ThingModelApi";
import ThingModelStorage from "@/storage/ThingModelStorage";
import TslStorage from "@/storage/TslStorage";
import _ from "lodash";
import ResourceStorage from "@/storage/ResourceStorage";

export abstract class ThingModelModule {
    /**
     * 当前活跃的物模型
     */
    abstract thingModel: ThingModel

    abstract tsl: Tsl

    abstract resource: Resource

    abstract resourceOrNull: Resource | null

    abstract resources: Array<Resource>

    abstract isActive(): Promise<boolean>

    abstract activate(productId: number): Promise<void>

    abstract inactivate(): Promise<void>

    abstract activateResource(resource: Resource): Promise<void>

    abstract inactivateResource(): Promise<void>

    abstract destroy(): Promise<void>
}

@Module({dynamic: true, store, namespaced: true, name: 'thingModel'})
class ThingModelModuleImpl extends VuexModule implements ThingModelModule {

    private thingModelApi = Container.get(ThingModelApi)

    private thingModelStorage = Container.get(ThingModelStorage)

    private tslStorage = Container.get(TslStorage)

    private resourceStorage = Container.get(ResourceStorage)

    tmodelOrNull = this.thingModelStorage.getOrNull()

    tslOrNull = this.tslStorage.getOrNull()

    resourceOrNull = this.resourceStorage.getOrNull()

    get thingModel() {
        return this.tmodelOrNull ?? new ThingModel()
    }

    get tsl() {
        return this.tslOrNull ?? new Tsl()
    }

    get resource() {
        return this.resourceOrNull ?? new class extends Resource {
        }
    }

    get resources() {
        return _.concat(
            new Array<Resource>(),
            this.thingModel.properties,
            this.thingModel.events,
            this.thingModel.services
        )
    }

    isLogged = this.thingModelStorage.exist()

    @Action
    async isActive(): Promise<boolean> {
        return this.tmodelOrNull != undefined
            && this.tslOrNull != undefined
    }

    @Action
    async activate(productId: number): Promise<void> {
        const tmodel = await this.thingModelApi.query(productId)
        this.activateTmodel(tmodel)

        // const tsl = await this.thingModelApi.queryTsl(productId)
        // this.activateActiveTsl(tsl)
    }

    @Action
    async activateTmodel(thingModel: ThingModel) {
        this.setThingModel(thingModel)
        this.thingModelStorage.set(thingModel)
    }

    @Action
    async activateActiveTsl(tsl: Tsl) {
        this.setTsl(tsl)
        this.tslStorage.set(tsl)
    }

    @Action
    async inactivate(): Promise<void> {
        this.inactivateTmodel()
        this.inactivateTsl()
    }

    @Action
    async inactivateTmodel(): Promise<void> {
        this.removeTmodel()
        this.thingModelStorage.remove()
    }

    @Action
    async inactivateTsl(): Promise<void> {
        this.removeTsl()
        this.tslStorage.remove()
    }

    @Action
    async activateResource(resource: Resource): Promise<void> {
        this.setResource(resource)
        this.resourceStorage.set(resource)
    }

    @Action
    async inactivateResource(): Promise<void> {
        this.removeResource()
        this.resourceStorage.remove()
    }

    @Action
    async destroy(): Promise<void> {
        this.inactivate()
        this.inactivateResource()
    }

    @Mutation
    private setThingModel(thingModel: ThingModel) {
        this.tmodelOrNull = thingModel
    }

    @Mutation
    private setTsl(tsl: Tsl) {
        this.tslOrNull = tsl
    }

    @Mutation
    private removeTmodel() {
        this.tmodelOrNull = null
    }

    @Mutation
    private removeTsl() {
        this.tslOrNull = null
    }

    @Mutation
    private setResource(resource: Resource) {
        this.resourceOrNull = resource
    }

    @Mutation
    private removeResource() {
        this.resourceOrNull = null
    }
}

const thingModelModule: ThingModelModule = getModule(ThingModelModuleImpl)
export default thingModelModule
